import React from "react";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { BundleShowcase } from "./components/BundleShowcase";
import { PainSection } from "./components/PainSection";
import { GuidesSection } from "./components/GuidesSection";
import { BonusSection } from "./components/BonusSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { AudienceSection } from "./components/AudienceSection";
import { OfferSection } from "./components/OfferSection";
import { FaqSection } from "./components/FaqSection";
import { FinalCta } from "./components/FinalCta";
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="31cjo20c63n1d">
      <PromoBar data-id="element-1" data-mp="2wj8f9tnsow6t" />
      <Hero data-id="element-2" data-mp="2wip7h5ruzo6i" />
      <main data-id="element-3" data-mp="2wi5n7ieqknpb">
        <BundleShowcase data-id="element-4" data-mp="28ufnm9e7hai0" />
        <PainSection data-id="element-5" data-mp="28tmfp53igeya" />
        <GuidesSection data-id="element-6" data-mp="28t4ju9krg2qw" />
        <BonusSection data-id="element-7" data-mp="28sbcb6dz997p" />
        <AudienceSection data-id="element-8" data-mp="23vcikoy874a1" />
        <OfferSection data-id="element-9" data-mp="23w4drynwuzzs" />
        <TestimonialsSection data-id="element-10" data-mp="23utcc5hxu4bu" />
        <FaqSection data-id="element-11" data-mp="23ti864kkyuk7" />
      </main>
      <FinalCta data-id="element-12" data-mp="3ikh9me1wn113" />
    </div>;
}